


export const logKeys = {
  type:"locationOfGoods.type",
  qualifierId:"locationOfGoods.qualifierId",
  authorisationNumber:"locationOfGoods.authorisationNumber",
}

export const warehouseKeys = {
  type:'warehouse.type',
  id:"warehouse.id"
}

export const countryInfoKeys = {
  originCountry :"countryInfo.originCountry",
  destinationCountry:"countryInfo.destinationCountry"
}

export const deliveryKeys={
  incoTerms:'deliveryTerms.incoTerms',
  country:'deliveryTerms.country',
  place:'deliveryTerms.place',
  
}

const EUCOUNTRIES = ["DE","BE","HR","DK","ES","FR","IE","LV","LU","NL","SE","BG","SK","EE","GR","MT","PL","CZ","AT","CY","SI","FI","HU","IT","LT","PT","RO"]
let actorArray= ["declarantsList","consigneeList","exportersList","carriersList"]

const createPartiesPattern=(translate)=>{
  return ["consignorsList","consigneeList", "carriersList", "declarantsList", "exportersList","representativesList","sellersList"].reduce((prev,curr)=>{
    return {...prev,
      [curr]:{
      [`name`]:{
          presence:false,
          length: {
            maximum: 70,
            message:`^${translate('Length_of')} ${translate('NAME')} ${translate('should_be_max')} 70 ${translate('characters')}`
          },
          format:{
            pattern:/^[a-zA-Z0-9., ]*$/,
            message:`^${translate('NAME')} ${translate('can_only_contain')} ${translate('can_only_contain_alphanumeric_dot_and_comma_characters')}`
          }
      },
      [`eoriNo`]: {
        presence: !actorArray.includes(curr) ? false : function(value, attribute, validatorOptions, attributes, globalOptions) {
          return EUCOUNTRIES.includes(attribute?.country) ? {message:`^${translate('EORI_NO')} ${translate('is_mandatory')}`, allowEmpty:false} : false
        },
        length: {
          minimum:11,
          maximum: 17,
          message:`^${translate('EORI_NO')} ${translate('should_be')} ${translate('from')} 10 ${translate('to')} 17 ${translate('digit')}`
        }
      },
      [`addressLine1`]: {
        presence:false,        
        length: {
          maximum: 70,
          message:`^${translate('Length_of')}  ${translate('Address_Line')} 1 ${translate('should_be_max')} 70 ${translate('characters')}`
        },
        format:{
          pattern:/^[a-zA-Z0-9., ]*$/,
          message:`^${translate('Address_Line')} 1 ${translate('can_only_contain_alphanumeric_dot_and_comma_characters')}`
        }
      },
      [`addressLine2`]: {
        presence:false,        
        length: {
          maximum: 70,
          message:`^${translate('Length_of')}  ${translate('Address_Line')} 2 ${translate('should_be_max')} 70 ${translate('characters')}`
        },
        format:{
          pattern:/^[a-zA-Z0-9., ]*$/,
          message:`^${translate('Address_Line')} 2 ${translate('can_only_contain_alphanumeric_dot_and_comma_characters')}`
        }
      },
      [`city`]: {
        presence:false,        
        length: {
          maximum: 35,
          message:`^${translate('Length_of')}  ${translate('CITY')} ${translate('should_be_max')} 35 ${translate('characters')}`
        },
        format:{
          pattern:/^[a-zA-Z0-9., ]*$/,
          message:`^${translate('CITY')} ${translate('can_only_contain_alphanumeric_dot_and_comma_characters')}`
        }
      },
      [`state`]: {
        presence:false,        
        length: {
          maximum: 35,
          message:`^${translate('Length_of')}  ${translate('STATE')} ${translate('should_be_max')} 35 ${translate('characters')}`
        },
        format:{
          pattern:/^[a-zA-Z0-9., ]*$/,
          message:`^${translate('STATE')} ${translate('can_only_contain_alphanumeric_dot_and_comma_characters')}`
        }
      },
      [`postalCode`]: {
        presence:false,       
        length: {
          maximum: 17,
          message:`^${translate('Length_of')} ${translate('ZIP_CODE')} ${translate('should_be_max')} 17 ${translate('characters')}`
        },
        format:{
          pattern:/^[a-zA-Z0-9 ]*$/,
          message:`^${translate('ZIP_CODE')} ${translate('can_only_contain_alphanumeric_characters')}`
        }
      },
      [`country`]:{
         presence:false
      }
    }
  }
  },{})
}


export const fieldPatterns = (isImportShipment,translate) => {
  if (isImportShipment) {
    return (dependentParams = {}) => ({})
  }
  return (dependentParams = {}) => ({
    headerTab: {
      declType: { presence: { message: `^${translate('DEC_TYPE')} ${translate('is_mandatory')}`, allowEmpty: false } },
      declaration:{ presence: { message: `^${translate('DECLARATION')} ${translate('is_mandatory')}`, allowEmpty: false } }
    },
    transportTab:{

      countryInfo:{
      [countryInfoKeys.originCountry]:{
        presence:{message:`^${translate('COUNTRY_DISPATCH')} ${translate('is_mandatory')}`, allowEmpty:false},
      },
      [countryInfoKeys.destinationCountry]:{
        presence:{message:`^${translate('COUNTRY_OF_DESTINATION')} ${translate('is_mandatory')}`, allowEmpty:false},
      }
      },


      security:{presence:{message:`^${translate('SECURITY')} ${translate('is_mandatory')}`, allowEmpty:false}},
      
     activeTransportMeansList:{
      identification:{
        presence:{message:`^${translate('IDENTIFICATION')} ${translate('is_mandatory')}`, allowEmpty:false},
        format: {
          pattern: /^[a-zA-Z0-9 ]*$/,
          message: `${translate('IDENTIFICATION')} ${translate('can_only_contain_alphanumeric_and_space_characters')}`
        },
        length: {
          maximum:35,
          message: `^${translate('max_length_of')} PLACE ${translate('should_be')} 35`
        }
      
      },
      type:{presence:{message:`^${translate('TYPE')} ${translate('is_mandatory')}`, allowEmpty:false}},
      nationality:{presence:{message:`^${translate('NATIONALITY')} ${translate('is_mandatory')}`, allowEmpty:false}},
     },

     locationOfGoods:{
      [logKeys.authorisationNumber]:{
        presence:(dependentParams?.qualifierId!='Y')? false : {message:`^${translate('AUTH_NUMBER')} ${translate('is_mandatory')}`, allowEmpty:false},
        format: {
          pattern: /^[a-zA-Z0-9 ]*$/,
          message: `^${translate('AUTH_NUMBER')}${translate('can_only_contain_alphanumeric_and_space_characters')}`
        },
        length: {
          maximum:35,
          message: `^${translate('max_length_of')}PLACE ${translate('should_be')} 10`
        }
      
      },

      [logKeys.type]:{presence:{message:`^${translate('GOODS_LOCATION')} ${translate('TYPE')} ${translate('is_mandatory')}`, allowEmpty:false}},
      [logKeys.qualifierId]:{
        presence:{message:`^${translate('GOODS_LOCATION')} ${translate('QUALIFIER_ID')} ${translate('is_mandatory')}`,allowEmpty:false},

      },
     },

    //  warehouse:{
    //   [warehouseKeys.type]:{presence:{message:'^WAREHOUSE TYPE is mandatory', allowEmpty:false}},
    //   [warehouseKeys.id]:{
    //     presence:{message:'^WAREHOUSE ID is mandatory', allowEmpty:false},
    //     format: {
    //       pattern: /^[a-zA-Z0-9 ]*$/,
    //       message: `^WAREHOUSE ID can only contain alphanumeric and space characters.`
    //     },
    //     length: {
    //       maximum:35,
    //       message: "^max length of PLACE should be 10"
    //     }
    //   }
    //  },

 
    departureTransportMeansList:{
      type:{
        presence: !(['1','2','3','4','8'].includes(dependentParams?.inlandTransportMode))?false :  {message:`^${translate('TYPE')} ${translate('is_mandatory')}`, allowEmpty:false},
        format: {
          pattern: "",
          message: function(value, attribute, validatorOptions, attributes, globalOptions) {
            const pattern=new RegExp('^' + dependentParams?.inlandTransportMode)
            const msg=`^${translate('TYPE')} ${translate('can_only_start_with')} ${dependentParams?.inlandTransportMode} ${translate('as')} ${translate('INLAND_MOT')}`
            if(['1','2','3','4','8'].includes(dependentParams?.inlandTransportMode)){
              if(!(pattern).test(value))
                    return msg
               return "^"
            }else{
              return "^"
            }
          }
        }
      
      },
      identification:{
        presence:{message:`^${translate('IDENTIFICATION')} ${translate('is_mandatory')}`, allowEmpty:false},
      }
  
     },



  
    },
    parties: {
      ...createPartiesPattern(translate),
      authorizationsList:{
        type:{
          presence:{message:`^${translate('TYPE')} ${translate('is_mandatory')}`, allowEmpty:false}
        }
      },
      additionalSupplyChainActorsList:{
        role:{
          presence:{message:`^${translate('ROLE')} ${translate('is_mandatory')}`, allowEmpty:false}
        }
      }
    
    },
    itemsTab: {
      invoice:{
        deliveryTerms:{
        [deliveryKeys.incoTerms]:{
          presence: { message: `^${translate('INCOTERMS')} ${translate('is_mandatory')}`, allowEmpty: false },
        },
        [deliveryKeys.country]:{
          presence: { message: `^${translate('COUNTRY')} ${translate('is_mandatory')}`, allowEmpty: false },
        },
        [deliveryKeys.place]:{
          presence: { message: `^${translate('PLACE')} ${translate('is_mandatory')}`, allowEmpty: false },
        },
      }
    },
      lineItem:{
       
        commercialDescription:{
          presence: {allowEmpty: false, message: `^${translate('COMMERCIAL_DESC')} ${translate('is_mandatory')}` },
          format: {
            pattern: /^[a-zA-Z0-9 ]*$/,
            message: `^${translate('COMMERCIAL_DESC')} ${translate('can_only_contain_alphanumeric_and_space_characters')}`
          },
          length: {
            maximum:35,
            message: `${translate('max_length_of')} ${translate('COMMERCIAL_DESC')} ${translate('should_be')} 512.`
          }
        },
        grossMass: {
          presence:{ allowEmpty: false, message:`^${translate('GROSS_MASS')} ${translate('is_mandatory')}` },
          format: {
            pattern: /^[0-9]{0,11}(?:\.[0-9]{0,3})?$/,
            message: `^${translate('GROSS_MASS')} ${translate('can_only_contain_numeric_values_with_max')} 11 ${translate('digit')} ${translate('and')} 2 ${translate('decimal_digits')}`
          }
        },
        netMass:{
          presence: {allowEmpty: false, message: `^${translate('NET_MASS')} ${translate('is_mandatory')}`},
          format: {
            pattern: /^[0-9]{0,11}(?:\.[0-9]{0,3})?$/,
            message: `^${translate('NET_MASS')} ${translate('can_only_contain_numeric_values_with_max')}  ${translate('digit')} ${translate('and')} 2 ${translate('decimal_digits')}`
          }
        },
        procedure:{
          presence: {allowEmpty: false, message:`^${translate('PROCEDURE')} ${translate('is_mandatory')}`},

        },
        commodityCode:{
          presence:{ allowEmpty: false, message: `^${translate('HTS_CODE')} ${translate('is_mandatory')}`}
        },
        statisticalValue:{
          presence:{ allowEmpty: false, message:`^${translate('STAT_VALUE')} ${translate('is_mandatory')}`}
        }

      },
      previousDocumentsList:{
        type: {
          presence : {
            allowEmpty:false, message:`^${translate('TYPE')} ${translate('is_mandatory')}`
          }
        },
      reference:{
        presence : {
          allowEmpty:false, message:`^${translate('REF')} ${translate('is_mandatory')}`
        }
      }
      },
      supportingDocumentsList:{
        type:{
          presence:{
            allowEmpty:false, message:`^${translate('TYPE')} ${translate('is_mandatory')}`
          }
        },
        reference:{
          presence:{
            allowEmpty:false, message:`^${translate('REFERENCE')} ${translate('is_mandatory')}`
          },
          // format:{
          //    pattern:'',
          //    message:function(value,attribute, validatorOptions, attributes, globalOption){
          //     const msg=`^${(inIdx && liIdx && pdIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: SUPPORT DOCUMENT REFERENCE 00${pdIdx} :: `:""} REFERENCE should be start with ESE as Type is N003 and should be 16 digits.`
          //     if(attribute.type === 'N003' && (value.length<16 || value.startsWith('ESE'))){
          //       return msg;
          //     }else{
          //       return "^"
          //     }
          //        }
          //    },
          // length:{
          //   is:16,
          //   message:function(value,attribute, validatorOptions, attributes, globalOption){
          //     const msg=`^${(inIdx && liIdx && pdIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: SUPPORT DOCUMENT REFERENCE 00${pdIdx} :: `:""} SUPPORT DOCUMENT REFERENCE should be 16 digits.`
          //     if(attribute.type === 'N003'){
          //             return msg;
          //           }else{
          //             return "^"
          //           }
          //   }
            
          // }
        }
      },
      additionalDocumentsList:{
        type:{
          presence:{
            allowEmpty:false, message:`^${translate('TYPE')} ${translate('is_mandatory')}`
          }
        },
        identification:{
          presence:{
            allowEmpty:false, message:`^${translate('IDENTIFICATION')} ${translate('is_mandatory')}`
          }
        }
      },
      packagesList:{
        type:{
          presence:{
            allowEmpty:false, message:`^${translate('PKG_TYPE')} ${translate('is_mandatory')}`
          }
        },
        quantity:(value,attribute, validatorOptions, attributes, globalOption)=>{

          return{  presence: !(['VL','VO','VQ','VR','VS','VY'].includes(attribute?.type)) ? {
             allowEmpty:false, 
             message:`^${translate('IF')} ${translate('PKG_TYPE')} ${translate('is_not')}  VL, VO, VQ, VR, VS, ${translate('or')} VY ${translate('then')} ${translate('PKG_QTY')} ${translate('is_mandatory')}`
           }:false}
       },
        shippingMarks:(value,attribute, validatorOptions, attributes, globalOption)=>{
          return { presence: !(['VL','VO','VQ','VR','VS','VY','NE','NF','NG'].includes(attribute?.type)) ? {
              allowEmpty:false, 
              message:`^${translate('IF')} ${translate('PKG_TYPE')} ${translate('is_not')} VL, VO, VQ, VR, VS, VY, NE, NF ${translate('or')} NG ${translate('then')}  ${translate('SHIPPING_MARKS')} ${translate('is_mandatory')}`
            }:false
          }
        }
      }
    },
  })
}
